import { main } from "@popperjs/core";
import Icon from "assets/icons";
import { ReactElement } from "react";
import { Outlet } from "react-router-dom";

const DefaultLayout = () => {
  const backgroundImage = "/img/Loginpagefinal1.png";
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-center bg-cover blur-sm scale-110"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      ></div>
      <div className="absolute inset-0 bg-white bg-opacity-30"></div>
      <Outlet />
    </div>
  );
};

export default DefaultLayout;
